/**
 * Handles the validation of review form ratings.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["error", "reviewItem"];
  static values = {
    errorMessage: {
      type: String,
      default: "Please select a rating for all items",
    },
  };

  // CSS classes for invalid review items
  errorClasses = [
    "outline-2",
    "outline-warning",
    "outline-dotted",
    "rounded-box",
  ];

  /**
   * Handles the modal closed event by hiding any validation errors
   * and removing error styling from review items.
   */
  handleModalClosed() {
    // Hide the error message
    this.errorTarget.classList.add("hidden");

    // Remove error styling from all review items
    this.reviewItemTargets.forEach((item) => {
      item.classList.remove(...this.errorClasses);
    });
  }

  /**
   * Validates the form before submission to ensure all items have ratings.
   */
  validate(event) {
    let isValid = true;

    this.reviewItemTargets.forEach((item, index) => {
      // Only check visible radio buttons (ignore the hidden one used for DaisyUI)
      const ratingInputs = item.querySelectorAll(
        'input[type="radio"][name*="[rating]"]:not(.rating-hidden)'
      );

      const hasRating = Array.from(ratingInputs).some((input) => {
        return input.checked;
      });

      if (!hasRating) {
        isValid = false;
        item.classList.add(...this.errorClasses);
      } else {
        item.classList.remove(...this.errorClasses);
      }
    });

    if (!isValid) {
      event.preventDefault();
      this.errorTarget.classList.remove("hidden");
    } else {
      this.errorTarget.classList.add("hidden");
    }
  }
}
